<template>
    <div class="tw-w-full tw-mx-auto 3xl:tw-max-w-screen-3xl 4xl:tw-max-w-screen-4xl tw-px-4 md:tw-px-8">
        <Breadcrumb :breadcrumbs />

        <PageHeader
            :title="`Content Updates: New, Returning & Leaving - ${month}`"
        />

        <div class="tw-mt-[30px]">
<!--            <MiniCatalogueSection-->
<!--                v-if="comingSoon?.data?.length"-->
<!--                title="Coming Soon"-->
<!--                seeAllAriaLabel="See All Coming Soon"-->
<!--                :seeAllUrl="`/${brand}/content-updates/coming-soon`"-->
<!--                :preLoadedContent="comingSoon?.data"-->
<!--            />-->

            <MiniCatalogueSection
                v-if="returning?.length"
                title="Returning"
                seeAllAriaLabel="See All Returning"
                :seeAllUrl="`/${brand}/content-updates/returning`"
                :preLoadedContent="returning"
            />

            <MiniCatalogueSection
                v-if="leaving?.length"
                title="Leaving"
                seeAllAriaLabel="See All Leaving"
                :seeAllUrl="`/${brand}/content-updates/leaving`"
                :preLoadedContent="leaving"
            />
        </div>
    </div>
</template>
<script setup>
import { onBeforeMount, ref } from "vue";
import { usePlatformStore } from "@stores/platform";
import { useUserStore } from "@stores/user";
import { storeToRefs } from "pinia/dist/pinia";
import { fetchReturning, fetchLeaving } from 'musora-content-services';

import Breadcrumb from '@collections/Breadcrumb/Breadcrumb.vue';
import PageHeader from '@collections/PageHeader/PageHeader.vue';
import MiniCatalogueSection from '@collections/MiniCatalogueSection/MiniCatalogueSection.vue';

const props = defineProps({
    month: {
        type: String,
        default: '',
    },
})

const userStore = useUserStore();
const { brand } = storeToRefs(userStore);
const platformStore = usePlatformStore();

const leaving = ref([]);
const returning = ref([]);
const comingSoon = ref([]);

const breadcrumbs = [
    {
        title: 'Content Updates',
    },
];

onBeforeMount(() => {
    const fetchData = async () => {
        const [leavings, returnings] = await Promise.all([
            fetchLeaving(brand.value),
            fetchReturning(brand.value),
        ]);

        leaving.value = leavings || [];
        returning.value = returnings || [];
    }

    fetchData();
    platformStore.setLoadingState(false);
})
</script>
